import api from '@pray/shared/utils/api';
import type { CatalogResponse } from './types';
type Props = { artistId: string; name: string; slug: string; description?: string };
export async function postCreateCatalog({ artistId, name, slug, description }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Returns the minimal created-catalog DTO (id/name/slug/…); callers only read `id`
  // for navigation and refetch the full catalog. Unwrap the envelope one level — see getCatalogs.ts.
  const res = await api.executePostRequest<{ data: CatalogResponse }>(`/web/studio/artists/${artistId}/catalogs`, {
    name, slug, description: description || null,
  });
  return res.data.data;
}
